module.exports = __webpack_public_path__ + "static/media/25_A.3fb77a42.png";